import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/AdminLayout';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import MembreDashboard from './pages/MembreDashboard';
import Projets from './pages/Projets';
import Parcelles from './pages/Parcelles';
import Membres from './pages/Membres';
import MembreDetail from './pages/MembreDetail';
import Versements from './pages/Versements';
import Charges from './pages/Charges';
import Documents from './pages/Documents';
import Articles from './pages/Articles';
import Messages from './pages/Messages';
import Tirages from './pages/Tirages';
import Parametrage from './pages/Parametrage';
import MesParcelles from './pages/MesParcelles';
import MesVersements from './pages/MesVersements';
import MesDocuments from './pages/MesDocuments';
import Profil from './pages/Profil';
import Messagerie from './pages/Messagerie';
import Cartographie from './pages/Cartographie';
import Statistics from './pages/Statistics';
import Chargements from './pages/Chargements';
import ProjetDetail from './pages/ProjetDetail';
import MaCartographie from './pages/MaCartographie';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/projet/:id" element={<ProjetDetail />} />
          <Route path="/login" element={<Login />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<DashboardRouter />} />
              <Route path="projets" element={<Projets />} />
              <Route path="parcelles" element={<Parcelles />} />
              <Route path="membres" element={<Membres />} />
              <Route path="membres/:id" element={<MembreDetail />} />
              <Route path="versements" element={<Versements />} />
              <Route path="charges" element={<Charges />} />
              <Route path="documents" element={<Documents />} />
              <Route path="articles" element={<Articles />} />
              <Route path="messages" element={<Messages />} />
              <Route path="tirages" element={<Tirages />} />
              <Route path="messagerie" element={<Messagerie />} />
              <Route path="cartographie" element={<Cartographie />} />
              <Route path="chargements" element={<Chargements />} />
              <Route path="statistiques" element={<Statistics />} />
              <Route path="parametrage/:table" element={<Parametrage />} />
              <Route path="mes-parcelles" element={<MesParcelles />} />
              <Route path="ma-cartographie" element={<MaCartographie />} />
              <Route path="mes-versements" element={<MesVersements />} />
              <Route path="mes-documents" element={<MesDocuments />} />
              <Route path="profil" element={<Profil />} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

// Router component to switch between admin and member dashboard
function DashboardRouter() {
  const { useAuth } = require('./contexts/AuthContext');
  const { isAdmin } = useAuth();
  return isAdmin() ? <Dashboard /> : <MembreDashboard />;
}

export default App;
